export enum ROUTES {
  DASHBOARD = '/dashboard'
}
